const saleSchema = [
  {
    name: 'hideNewSale',
    initialValue: '',
    input: {
      placeholder: 'New Sale',
      className: 'hideNewSale',
      label: 'New Sale',
      type: 'checkbox',
    },
  },
  {
    name: 'hideSaveSale',
    initialValue: '',
    input: {
      placeholder: 'Save as Order',
      className: 'hideSaveSale',
      label: 'Save as Order',
      type: 'checkbox',
    },
  },
  {
    name: 'hideLayaways',
    initialValue: '',
    input: {
      placeholder: 'Save as Layaway',
      className: 'hideLayaways',
      label: 'Save as Layaway',
      type: 'checkbox',
    },
  },
  {
    name: 'hideDiscount',
    initialValue: '',
    input: {
      placeholder: 'Discount',
      className: 'hideDiscount',
      label: 'Discount',
      type: 'checkbox',
    },
  },
  {
    name: 'hideTaxExcempt',
    initialValue: '',
    input: {
      placeholder: 'Tax Exempt',
      className: 'hideTaxExcempt',
      label: 'Tax Exempt',
      type: 'checkbox',
    },
  },
  {
    name: 'hideNotes',
    initialValue: '',
    input: {
      placeholder: 'Notes',
      className: 'hideNotes',
      label: 'Notes',
      type: 'checkbox',
    },
  },
  {
    name: 'hideLastReceiptPrint',
    initialValue: '',
    input: {
      placeholder: 'Last Receipt',
      className: 'hideLastReceiptPrint',
      label: 'Last Receipt',
      type: 'checkbox',
    },
  },
  {
    name: 'hideOpenCashDrawer',
    initialValue: '',
    input: {
      placeholder: 'Cash Drawer',
      className: 'hideOpenCashDrawer',
      label: 'Cash Drawer',
      type: 'checkbox',
    },
  },
  {
    name: 'hidePromotions',
    initialValue: '',
    input: {
      placeholder: 'Promotions',
      className: 'hidePromotions',
      label: 'Promotions',
      type: 'checkbox',
    },
  },
  {
    name: 'hideCoupons',
    initialValue: '',
    input: {
      placeholder: 'Coupons',
      className: 'hideCoupons',
      label: 'Coupons',
      type: 'checkbox',
    },
  },
  {
    name: 'hidePrintGiftcardReceipt',
    initialValue: '',
    input: {
      placeholder: 'Print Gift Receipt',
      className: 'hidePrintGiftcardReceipt',
      label: 'Print Gift Receipt',
      type: 'checkbox',
    },
  },
  {
    name: 'hideAddShipping',
    initialValue: '',
    input: {
      placeholder: 'Add Shipping',
      className: 'hideAddShipping',
      label: 'Add Shipping',
      type: 'checkbox',
    },
  },
];

export default saleSchema;
